<template>
  <div class="container" v-loading="saving">
    <div class="leftMenu">
      <div class="menu-container">
        <el-tooltip class="item" effect="dark"
                    :content="addNew"
                    placement="bottom">

          <i class="icon-add " @click="add"></i>
        </el-tooltip>
        <div
          v-for="item in menuItems" :key="item.label" @click="menuHandler(item)" class="menu-item  noSelect"
          :class="{'active':item.label === active}">
          <i :class="item.icon"></i>
          <span> {{item.label}}</span>
        </div>


        <div class="underline"></div>

      </div>


    </div>

    <div class="content">
      <div class="header">
        <span v-if="!toggleEditLabel" id="label"> {{project.name}}</span>
        <input
          ref="editLabel" v-model="project.name" v-show="toggleEditLabel" @keyup.enter="toggleEditLabel=false "
          :placeholder="project.name"/>
        <i class="icon-pencil" @click="toggleEditLabel=!toggleEditLabel; $nextTick(()=>{$refs.editLabel.focus()})"></i>
        <div class="right" @click="slideInSettings"><i class="icon-cogwheel-outline"></i></div>

      </div>
      <div class="current_tab" :class="{'slideOut':slideSettings?'':!slideSettings } ">
        <component v-if="active" :is="tab" class=""></component>


      </div>
      <div class="settings" :class="{'slideIn':slideSettings?'':!slideSettings }">
        <settings></settings>
      </div>
      <div class="footer">
        <button class="save" @click="save()">save</button>
        <button class="cancel" @click="cancel">cancel</button>
      </div>
    </div>

  </div>
</template>

<script>
  import devices from './devices/devices'
  import alarms from './alarms/alarms'
  import triggers from './triggers/triggers'
  import settings from './project-settings/settings'
  import newGateWay from '../../../views/settings/newGateWay/newGateWay.vue'
  import {post} from '../../../API/cloudFunctions'
  import errorMixin from '../../mixins/errorMixin'


  export default {
    //mixins are used to share  reusable code between components
    mixins: [errorMixin],
    data() {
      return {visible: false, tabIndex: 0}
    },
    components: {devices, alarms, triggers, settings, newGateWay},

    methods: {

      add() {
        console.log('add')
        if (this.active == 'Devices') {
          this.active = 'newGateWay';
          console.log('newGateWay')
        }
      },
      cancel() {
        this.$confirm('Are you sure you want to close this dialog?', '', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })
          .then(_ => {
            this.$store.dispatch('showModal')

            done();
          })
          .catch(_ => {
          });
      },
      save() {
        this.saving = true;
        this.$store.dispatch('addProject', this.project).then(success => {
          this.saving = false;
          this.$store.dispatch('showModal')
        }).catch(error => {
            this.showError('was unable to save the project :' + error);
            console.error(error);
            this.saving = false;
          }
        )

      },
      menuHandler(item) {
        this.active = item.label;
      },
      slideInSettings() {
        this.slideSettings = !this.slideSettings;
        this.active = false

      }

    },
    computed: {
      tab() {
        this.slideSettings = true;
        switch (this.active) {
          case 'Devices':

            return devices;


          case 'Triggers':
            return triggers;


          case 'Alarms':

            return alarms;

          case 'newGateWay':

            return newGateWay;

          default :
            return null
        }

        return devices;
      },
      isActive(item) {

        return item.label === this.active

      },
      addNew() {
        if (!this.active) {
          return ''
        } else {
          return 'Add new ' + (this.active.substring(0, this.active.length - 1)).toLowerCase()
        }
      }
    },
    data() {
      return {
        menuItems: [{label: 'Devices', icon: 'icon-device'}, {
          label: 'Triggers',
          icon: 'icon-flash'
        }, {label: 'Alarms', icon: 'icon-alarm'}], active: 'Devices', toggleEditLabel: false, slideSettings: false,
        project: {name: 'Project Name', gateWay: [], devices: [], triggers: [], alarms: []},
        saving: false

      }
    }

  }
</script>

<style lang="scss" scoped>
  @import "./styles/variables";

  .container {
    height: 70%;
    width: 70%;
    margin: 0 auto;
    border-radius: 14px;
    box-shadow: $shadow;
    transition: all .3s ease;
    display: flex;
    .leftMenu {
      background-color: $blue;
      width: 78px;
      border-radius: 14px 0 0 14px;
      z-index: 101;
      cursor: pointer;

      .menu-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 20px;
        i {
          &.icon-add {
            font-size: 2rem;
            margin-bottom: 30px;
          }

        }

        .menu-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 30px;
          color: $grey;

          i {
            font-size: 2.6rem;
          }

          &.active {
            color: white;
          }

        }
      }
    }
    .content {
      width: calc(100% - 78px);
      height: auto;
      position: relative;
      overflow: hidden;
      .header {
        width: 100%;
        background: $grey;
        -webkit-box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.33);
        -moz-box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.33);
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.33);
        border-radius: 0 14px 0 0;
        height: 10%;
        z-index: 100;
        position: relative;
        display: flex;
        align-items: center;
        span {
          margin-left: 16px;
          margin-right: 8px;
        }
        input {
          margin-left: 16px;
          margin-right: 8px;
          width: 150px;
          height: 30px;
          padding-left: 4px;
          background-color: $lightGrey;
          border: white solid 1px;
          border-radius: 4px;
          color: white;
        }
        i {
          cursor: pointer;
        }
        .right {
          display: inline;
          position: absolute;
          right: 25px;
          top: 25px;
          font-size: 1.8rem;
          cursor: pointer;
          i {
            &:hover {
              color: $blue;
            }

          }
        }
      }
      .current_tab {
        width: 100%;
        background: $lightGrey;
        height: 80%;
        position: absolute;
        right: 0;
        transition: $slidTime;

        &.slideOut {
          right: 100%;

        }

      }
      .settings {
        background-color: $lightGrey;
        border-left: 1px $divider solid;
        height: 100%;
        width: calc(100% - 1px);
        left: 100%;
        position: absolute;
        transition: $slidTime;

        &.slideIn {
          left: -1px;
        }
      }
      .footer {
        width: 100%;
        background: $grey;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        height: 10%;
        z-index: 100;
        position: absolute;
        bottom: 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;

        button {
          width: 100px;
          height: 40px;
          border-radius: 2px;
          border: none;
          color: white;
          cursor: pointer;

          &.save {
            background-color: $blue;
          }
          &.cancel {
            margin-left: 25px;
            margin-right: 20px;
            background-color: $orange;
          }

        }
      }

    }
  }

  .el-tooltip__popper.is-dark {
    background-color: black !important;

  }
</style>



// WEBPACK FOOTER //
// src/views/project/create-project/index.vue